import React from 'react';
import { handleActionError } from '../../../utils/engineering-tools';
import { GreaseQuantityPayload, TimkenGreaseSpecificationType, TimkenUnit } from '../../../../components/bearing-search/types/types';
import { convertNumberInput, isValidRange } from '../../../utils/validations';

export type FillByPartNumberState = {
	unit: TimkenUnit;
	specsType: TimkenGreaseSpecificationType;
	loadDataID?: number;
	speedDataID?: number;
	percentageFillData?: number;
	requestData?: Partial<GreaseQuantityPayload>;
};

export const initialFillByPartNumberState: FillByPartNumberState = {
	unit: 'M',
	specsType: 'Timken',
};

export type FillByPartNumberAction =
	| { type: 'change_unit'; payload: TimkenUnit }
	| { type: 'change_specs_type'; payload: TimkenGreaseSpecificationType }
	| { type: 'change_speed_id'; payload: unknown }
	| { type: 'change_percentage_fill', payload: unknown }
	| { type: 'update_request_data' }
	| { type: 'reset'; payload: FillByPartNumberState };

const greaseFillByPartReducer: React.Reducer<
	FillByPartNumberState,
	FillByPartNumberAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_unit': {
			return {
				...state,
				unit: action.payload,
			};
		}
		case 'change_specs_type': {
			return {
				...state,
				specsType: action.payload,
			};
		}
		case 'change_speed_id': {
			return {
				...state,
				speedDataID: convertNumberInput( action.payload ),
			};
		}
		case 'change_percentage_fill': {
			return {
				...state,
				percentageFillData: convertNumberInput( action.payload ),
			};
		}
		case 'update_request_data': {
			const { speedDataID, unit, percentageFillData, specsType } = state;

			let requestData: Partial<GreaseQuantityPayload> | undefined;

			if ( specsType === 'Timken' ) {
				if ( speedDataID ) {
					requestData = { unit };
					requestData.speedDataID = speedDataID;
				}
			} else if ( isValidRange( percentageFillData, 0, 100, true ) ) {
				requestData = { unit, percentageFillData };
			}

			return {
				...state,
				requestData,
			};
		}
		case 'reset': {
			return {
				...action.payload,
			};
		}
	}

	return handleActionError( action );
};

export default greaseFillByPartReducer;
